<template lang="pug">
v-form.app-form(ref="form", lazy-validation, @submit.prevent="filterTravel")
  v-expansion-panels.app-expansion-panels(v-model="panel", elevation-0)
    v-expansion-panel
      v-expansion-panel-header.app-expansion-panel-header.mb-0
        h4.text
          v-icon(v-text="'filter_alt'")
          span(v-text="'Filtrar Viagens '")
      v-expansion-panel-content.app-expansion-panel-content
        v-row.mt-3
          v-col(cols="12", :lg="3", :md="3", :sm="6", :xs="12")
            v-autocomplete(
              :items="filter.origem.items",
              :loading="filter.origem.isLoading",
              :search-input.sync="searchOrigem",
              v-model="filter.origem.municipios",
              prepend-inner-icon="search",
              item-text="municipioNome",
              label="Origem *",
              autocomplete="off",
              return-object,
              clearable,
              outlined,
              placeholder="Pesquise",
              dense,
              hide-no-data,
              hide-selected
            )

            template(v-slot:selection="{ attr, on, item }")
              v-list-item
                v-list-item-title(v-text="item")

            template(v-slot:item="{ item }")
              v-list-item
                v-list-item-title(v-text="item")

          v-col(cols="12", :lg="3", :md="3", :sm="6", :xs="12")
            v-autocomplete(
              :items="filter.destino.items",
              :loading="filter.destino.isLoading",
              :search-input.sync="searchDestino",
              v-model="filter.destino.municipios",
              prepend-inner-icon="search",
              item-text="municipioNome",
              label="Destino *",
              autocomplete="off",
              return-object,
              clearable,
              outlined,
              placeholder="Pesquise",
              hide-no-data,
              hide-selected,
              dense
            )

            template(v-slot:selection="{ attr, on, item }")
              v-list-item
                v-list-item-title(v-text="item")

            template(v-slot:item="{ item }")
              v-list-item
                v-list-item-title(v-text="item")
          v-col(cols="12", :lg="3", :md="3", :sm="6", :xs="12")
            template
              v-text-field(
                v-model="filter.dataInicio",
                label="De",
                outlined,
                dense,
                clearable,
                type="date"
              ) 
          v-col(cols="12", :lg="3", :md="3", :sm="6", :xs="12")
            template
              v-text-field(
                v-model="filter.dataFim",
                label="Até",
                outlined,
                dense,
                clearable,
                type="date"
              ) 

          v-divider 
          v-col.d-flex.justify-end(
            cols="12",
            :lg="12",
            :md="12",
            :sm="12",
            :xs="12"
          )
            v-btn.mr-2.mt-2.mb-2.ml-2(
              outlined,
              color="error",
              type="button",
              @click.prevent.stop="clearFilter"
            )
              v-icon(size="18", v-text="'filter_alt_off'")
              //- span(v-text="'Limpar Filtros'")
            v-btn.mt-2.mb-2.ml-2(
              depressed,
              color="primary",
              type="submit",
              v-text="'Filtrar'",
              @click="search"
            )

        //- section.loading(v-if='table.isLoading')
        //-   v-progress-circular(indeterminate='' color='primary')
</template>

<script>
import GlobalStore from "@/store/modules/global";
import { Subject, throwError } from "rxjs";
import viagensService from "@/services/viagens.service";
import MunicipiosService from "@/services/municipios.service";
import dayjs from "dayjs";
import { mapState, mapActions } from "vuex";
import { getLocation } from "@/util/geolocation";

import {
  tap,
  debounceTime,
  distinctUntilChanged,
  switchMap,
} from "rxjs/operators";

export default {
  name: "Search",
  props: { pagination: [] },
  data: () => ({
    panel: null,
    filtro: {
      inicio: "",
    },
    filter: {
      origem: {
        isLoading: false,
        items: [],
        municipios: [],
      },
      destino: {
        isLoading: false,
        items: [],
        municipios: [],
      },
      dataInicio: null,
      dataFim: null,
    },
    subjectOrigem: new Subject(),
    subjectDestino: new Subject(),
    searchOrigem: null,
    searchDestino: null,
    paginationTravel: {},
    location: {},
    conection: "",
  }),
  computed: {
    ...mapState("viagens", ["table"]),
    ...mapState("viagens", ["updateTable"]),
    ...mapState("viagens", ["table.notSincronized.viagens.itens"]),
    ...mapState("viagens", ["hasTravelActive"]),
  },
  watch: {
    pagination: {
      handler() {
        this.search();
      },
      deep: true,
    },
    searchDestino(val) {
      if (val) {
        this.subjectDestino.next(val);
      }
    },
    searchOrigem(val) {
      if (val) {
        this.subjectOrigem.next(val);
      }
    },
    updateTable: function () {
      this.search();
      this.verifyIndexDB();
      // this.verify();
      // this.synchronizeTravelFinish();
      // this.synchronizeTraveInitial();
      // this.synchronizeTraveInitialBack();
    },
    conection: function () {
      this.verifyConection();
            this.synchronizeTravelFinish();
      this.synchronizeTraveInitial();
      this.synchronizeTraveInitialBack();
    },
  },
  async mounted() {
    await this.verifyIndexDB();
    this.searchTableCache();
    this.showPosition();
    this.municipiosDestino();
    this.municipiosOrigem();
    this.verifyConection();
    if (!this.table.tableOffline.offline) {
      this.search();
      this.synchronizeTravelFinish();
      this.synchronizeTraveInitial();
      this.synchronizeTraveInitialBack();
    }
  },

  methods: {
    search() {
      const {
        sortBy = [],
        sortDesc = [],
        page = 1,
        itemsPerPage = 5,
      } = this.pagination;
      const total = itemsPerPage <= 0 ? this.table.viagens.total : itemsPerPage;
      const municipioOrigemId =
        this.filter.origem.municipios.length === 0
          ? ""
          : this.filter.origem.municipios.municipioOrigemId;
      const municipioDestinoId =
        this.filter.destino.municipios.length === 0
          ? ""
          : this.filter.destino.municipios.municipioDestinoId;
      const dataInicio =
        this.filter.dataInicio === null
          ? ""
          : dayjs(this.filter.dataInicio).format("");
      const dataFim =
        this.filter.dataFim === null
          ? ""
          : dayjs(this.filter.dataFim)
              .add(23, "hour")
              .add(59, "minutes")
              .add(59, "seconds")
              .format("");

      viagensService
        .getTravel(
          page - 1,
          total,
          municipioOrigemId,
          municipioDestinoId,
          dataInicio,
          dataFim
        )
        .subscribe(
          (result) => {
            const arraytable = [];
            const { totalElements, content } = result;
            const refactor = [];
            content.forEach((value) => {
              const {
                id,
                dataInicio,
                dataFim,
                municipioOrigem,
                municipioDestino,
              } = value;
              (value.id = id),
                (value.origem = municipioOrigem.nome),
                (value.destino = municipioDestino.nome),
                (value.dataInicio = dayjs(dataInicio).format(
                  "DD/MM/YYYY HH:mm:ss"
                )),
                (value.dataFim = dayjs(dataFim).format("DD/MM/YYYY HH:mm:ss"));
            });

            this.table.tableOffline.offline = false;
            this.searchTravel({
              total: totalElements,
              itens: content,
              loading: false,
            });
            // this.synchronizeTravelFinish(this.location);
            // this.synchronizeTraveInitial();
            // this.synchronizeTraveInitialBack();
          },
          (error) => {
            throwError(error);
          }
        );
    },
    municipiosDestino() {
      this.subjectDestino
        .pipe(distinctUntilChanged())
        .pipe(tap(() => (this.filter.destino.isLoading = true)))
        .pipe(debounceTime(1000))
        .pipe(switchMap((value) => MunicipiosService.find(value)))
        .subscribe(
          (result) => {
            const municipiosList = [];

            result.forEach((value) => {
              municipiosList.push({
                municipioDestinoId: value.id,
                municipioNome: value.nome,
              });
            });

            // this.salvarMunicipiosStorage(municipiosList)
            this.filter.destino.items = municipiosList;
            this.filter.destino.isLoading = false;
          },
          (error) => {
            GlobalStore.setSnackBar({
              show: false,
              // message: "Ative sua localização",
              type: "success",
            });
            // this.StorageMunicipios();
            this.filter.destino.isLoading = false;
          }
        );
    },
    municipiosOrigem() {
      this.subjectOrigem
        .pipe(distinctUntilChanged())
        .pipe(tap(() => (this.filter.origem.isLoading = true)))
        .pipe(debounceTime(1000))
        .pipe(switchMap((value) => MunicipiosService.find(value)))
        .subscribe(
          (result) => {
            const municipiosList = [];

            result.forEach((value) => {
              municipiosList.push({
                municipioOrigemId: value.id,
                municipioNome: value.nome,
              });
            });

            // this.salvarMunicipiosStorage(municipiosList)
            this.filter.origem.items = municipiosList;
            this.filter.origem.isLoading = false;
          },
          (error) => {
            GlobalStore.setSnackBar({
              show: false,
              // message: "Ative sua localização",
              type: "success",
            });
            this.StorageMunicipios();
            this.filter.origem.isLoading = false;
          }
        );
    },
    filterTravel() {
      this.search();
    },
    clearFilter() {
      this.filter = {
        origem: {
          isLoading: false,
          items: [],
          municipios: [],
        },
        destino: {
          isLoading: false,
          items: [],
          municipios: [],
        },
        dataInicio: null,
        dataFim: null,
      };

      this.search();
    },
    showPosition() {
      getLocation().subscribe(
        (res) => {
          this.location.latitude = res.latitude;
          this.location.longitude = res.longitude;
        },
        (error) => {
          GlobalStore.setSnackBar({
            show: true,
            message: "Ative sua localização",
            type: "error",
          });
        }
      );
    },
    ...mapActions("viagens", { searchTravel: "SEARCH_TRAVEL" }),
    ...mapActions("viagens", { verifyIndexDB: "VERIFY_INDEXDB" }),
    ...mapActions("viagens", {
      synchronizeTraveInitial: "SYNCHRONIZE_TRAVEL_INITIAL",
    }),
    ...mapActions("viagens", {
      synchronizeTravelFinish: "SYNCHRONIZE_TRAVEL_FINISH",
    }),
    ...mapActions("viagens", {
      synchronizeTraveInitialBack: "SYNCHRONIZE_TRAVEL_INITIAL_BACK",
    }),
    ...mapActions("viagens", { verify: "VERIFY" }),
    ...mapActions("viagens", {
      saveTravelTableOffline: "SAVE_TRAVEL_TABLE_OFFLINE",
    }),

    searchTableCache() {
      viagensService.getTravel(0, 10, "", "", "", "").subscribe((res) => {
        res.content.forEach((e) => {
          e.origem = e.municipioOrigem.nome;
          e.destino = e.municipioDestino.nome;
          e.dataInicio =
            e.dataInicio === null
              ? e.dataInicio
              : dayjs(e.dataInicio).format("DD/MM/YYYY HH:mm:ss");
          e.dataFim =
            e.dataFim === null
              ? e.dataFim
              : dayjs(e.dataFim).format("DD/MM/YYYY HH:mm:ss");
        });
        this.saveTravelTableOffline(res.content);
      });
    },
    verifyConection() {
      window.addEventListener("online", () => {
        this.conection = true;
        this.verify();
        // this.synchronizeTravelFinish(this.location);
        // this.synchronizeTraveInitial();
        // this.synchronizeTraveInitialBack();
        this.searchTableCache();
        this.search();
      });
      window.addEventListener("offline", () => {
        this.verify();
        this.conection = false;
        this.table.tableOffline.offline = true;
      });
    },
  },
};
</script>
